import { CoreIcon } from '../core-icon';
import chevronDownSVG from '../../assets/icons/chevron-down.svg';
import type { IconProps } from '../core-icon';

export const ChevronDownIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronDownSVG} {...props} />;
};
